import IpubBacktop from './src/main'

/* istanbul ignore next */
IpubBacktop.install = function(Vue) {
  Vue.component(IpubBacktop.name, IpubBacktop)
}

export default IpubBacktop
